import React, { SVGProps } from "react"

export const Logo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="250"
      height="25"
      viewBox="0 0 261 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M170.305 16.3474C170.305 10.7483 165.803 6.24658 160.086 6.24658C154.369 6.24658 149.867 10.7483 149.867 16.3474C149.867 21.9464 154.369 26.4482 160.086 26.4482C165.803 26.4425 170.305 21.9408 170.305 16.3474ZM166.664 16.3474C166.664 20.2414 163.98 23.0381 160.086 23.0381C156.192 23.0381 153.559 20.2414 153.559 16.3474C153.559 12.4534 156.192 9.65665 160.086 9.65665C163.98 9.65103 166.664 12.4534 166.664 16.3474Z"
        fill="currentColor"
      />
      <path
        d="M241.703 26.1775H245.293V0.0223389H241.703V26.1775Z"
        fill="currentColor"
      />
      <path
        d="M259.925 6.84828H255.513V0H251.996V6.7076V9.87008V19.8865C251.996 22.9702 252.232 26.414 257.713 26.414C258.878 26.414 260.234 26.0876 261 25.5249V22.323C260.268 22.7676 259.12 23.1784 258.27 23.1784C255.451 23.1784 255.513 21.1413 255.513 18.9917V10.0108H259.925V6.84828Z"
        fill="currentColor"
      />
      <path
        d="M211.761 9.17229C210.202 6.92704 207.586 6.21802 205.464 6.21802C201.936 6.21802 198.413 8.16502 198.413 12.211C198.413 15.5648 200.867 16.7915 204.148 17.5512C205.695 17.9169 209.049 18.1758 209.049 20.6292C209.049 22.5031 207.681 23.4822 204.969 23.4203C202.623 23.3697 201.188 22.0191 200.118 20.8318L197.688 22.9926C199.595 25.3392 202.11 26.5547 205.205 26.5547C209.229 26.5547 212.566 24.5908 212.566 20.5054C212.566 16.8703 209.527 15.4916 206.77 14.9008C205.183 14.535 201.514 14.3605 201.829 11.7946C201.998 10.4159 203.686 9.30171 205.515 9.30171C206.77 9.30171 207.957 9.403 209.499 11.1249L211.761 9.17229Z"
        fill="currentColor"
      />
      <path
        d="M175.443 14.389V26.1611H179.146V15.2331C179.146 12.0369 180.26 9.49338 183.862 9.49338C187.463 9.49338 188.42 12.1888 188.42 15.1374V26.1611H192.111V14.5072C192.111 10.2587 189.877 6.17334 183.833 6.17334C177.683 6.17334 175.443 10.2024 175.443 14.389Z"
        fill="currentColor"
      />
      <path
        d="M234.669 18.2037V6.56104H231.023V17.5903C231.023 21.0004 230.117 23.2119 226.588 23.2119C223.06 23.2119 221.991 20.9554 221.991 17.5847V6.56104H218.316V18.1755C218.316 22.3847 220.584 26.4644 226.51 26.4644C232.553 26.4644 234.669 22.3453 234.669 18.2037Z"
        fill="currentColor"
      />
      <path
        d="M145.366 9.33007C143.459 7.25927 140.78 6.28577 137.983 6.28577C131.979 6.28577 127.922 10.5062 127.922 16.4259C127.922 22.3457 132.058 26.4423 137.983 26.4423C140.78 26.4423 143.38 25.5926 145.282 23.4824L142.688 20.8883C141.472 22.3064 140.054 23.0379 138.023 23.0379C134.252 23.0379 131.608 20.1174 131.608 16.5047C131.608 12.8977 133.842 9.69021 137.82 9.69021C139.846 9.69021 141.27 10.4217 142.609 11.8398L145.366 9.33007Z"
        fill="currentColor"
      />
      <path
        d="M17.4443 9.33007C15.5366 7.25927 12.8581 6.28577 10.0614 6.28577C4.0572 6.28577 0 10.5062 0 16.4259C0 22.3457 4.13598 26.4423 10.0614 26.4423C12.8581 26.4423 15.4579 25.5926 17.3655 23.4824L14.7714 20.8883C13.5559 22.3064 12.1378 23.0379 10.1064 23.0379C6.33621 23.0379 3.78709 20.1174 3.78709 16.5047C3.78709 12.8977 5.92542 9.69021 9.90384 9.69021C11.9296 9.69021 13.3533 10.4217 14.6869 11.8398L17.4443 9.33007Z"
        fill="#EF4130"
      />
      <path
        d="M42.975 16.3474C42.975 10.7483 38.4733 6.24658 32.7561 6.24658C27.0389 6.24658 22.5371 10.7483 22.5371 16.3474C22.5371 21.9464 27.0389 26.4482 32.7561 26.4482C38.4733 26.4425 42.975 21.9408 42.975 16.3474ZM39.3399 16.3474C39.3399 20.2414 36.6501 23.0381 32.7561 23.0381C28.8621 23.0381 26.2567 20.2414 26.2567 16.3474C26.2567 12.4534 28.8621 9.65665 32.7561 9.65665C36.6501 9.65103 39.3399 12.4534 39.3399 16.3474Z"
        fill="#EF4130"
      />
      <path
        d="M102.809 16.3474C102.809 10.7483 98.3073 6.24658 92.59 6.24658C86.8728 6.24658 82.3711 10.7483 82.3711 16.3474C82.3711 21.9464 86.8728 26.4482 92.59 26.4482C98.3073 26.4425 102.809 21.9408 102.809 16.3474ZM99.1682 16.3474C99.1682 20.2414 96.4841 23.0381 92.59 23.0381C88.696 23.0381 86.0625 20.2414 86.0625 16.3474C86.0625 12.4534 88.696 9.65665 92.59 9.65665C96.4841 9.65103 99.1682 12.4534 99.1682 16.3474Z"
        fill="#EF4130"
      />
      <path
        d="M109.764 26.1945H113.646L120.86 6.38123H117.141L109.764 26.1945Z"
        fill="#EF4130"
      />
      <path
        d="M76.9464 26.217V15.2046C76.9464 9.37484 74.2173 6.34741 68.8658 6.34741C66.3448 6.34741 64.2065 7.23088 62.901 9.26229C62.901 9.26229 62.6084 9.71247 62.5915 9.75186C62.569 9.71247 62.282 9.26229 62.282 9.26229C60.9765 7.23088 58.8438 6.34741 56.3228 6.34741C50.9714 6.34741 48.2422 9.36921 48.2422 15.2046V26.217H51.9167V15.4634C51.9167 11.9296 52.8734 9.70121 56.4185 9.70121C59.5641 9.70121 60.8358 12.0084 60.8358 15.3903V26.2114H64.3922V15.3959C64.3922 12.014 65.6302 9.70684 68.7758 9.70684C72.3209 9.70684 73.2775 11.9352 73.2775 15.4691V26.2226H76.9464V26.217Z"
        fill="#EF4130"
      />
    </svg>
  )
}

export const LinkedIn = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 21C4.7124 21 0 16.2876 0 10.5C0 4.7124 4.7124 0 10.5 0C16.2876 0 21 4.7124 21 10.5C21 16.2876 16.2876 21 10.5 21ZM10.5 0.84C5.1744 0.84 0.84 5.1744 0.84 10.5C0.84 15.8256 5.1744 20.16 10.5 20.16C15.8256 20.16 20.16 15.8256 20.16 10.5C20.16 5.1744 15.8256 0.84 10.5 0.84Z"
        fill="white"
      />
      <path
        d="M16.3128 11.0297V14.7005H13.944V11.0297C13.944 10.0133 13.3056 9.77807 13.0704 9.77807C12.8352 9.77807 12.0456 9.93767 12.0456 11.0297V14.7005H9.59277V7.98047H12.0456V8.92127C12.3648 8.37527 12.9948 7.98047 14.1792 7.98047C15.3636 7.98047 16.3128 8.92127 16.3128 11.0297Z"
        fill="white"
      />
      <path
        d="M7.82858 6.05743C7.82858 6.68743 7.35818 7.15783 6.56858 7.15783C5.86298 7.15783 5.39258 6.68743 5.39258 6.05743C5.39258 5.42743 5.86298 4.95703 6.65258 4.95703C7.35818 4.95703 7.82858 5.42743 7.82858 6.05743Z"
        fill="white"
      />
      <path
        d="M7.91258 7.98047H5.39258V14.7005H7.91258V7.98047Z"
        fill="white"
      />
    </svg>
  )
}

export const Facebook = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="11"
      height="19"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 11.2H3.4545V18H6.7273V11.2H8.7727L10 7.8H6.7273V5.39999C6.7273 4.84771 7.175 4.39999 7.7273 4.39999H9.5909V1C7.5457 1.00004 6.3181 1.00006 5.0909 1.85C3.8636 2.7 3.5555 3.72796 3.5133 4.71947C3.4545 6.10003 3.4545 6.95003 3.4545 7.8H1V11.2Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Instagram = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 1H5C2.79086 1 1 2.79086 1 5V13C1 15.2091 2.79086 17 5 17H13C15.2091 17 17 15.2091 17 13V5C17 2.79086 15.2091 1 13 1Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M8.99961 12.4016C10.8774 12.4016 12.3996 10.8793 12.3996 9.00156C12.3996 7.12379 10.8774 5.60156 8.99961 5.60156C7.12184 5.60156 5.59961 7.12379 5.59961 9.00156C5.59961 10.8793 7.12184 12.4016 8.99961 12.4016Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M13.5 5.5C14.0523 5.5 14.5 5.05228 14.5 4.5C14.5 3.94772 14.0523 3.5 13.5 3.5C12.9477 3.5 12.5 3.94772 12.5 4.5C12.5 5.05228 12.9477 5.5 13.5 5.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CircleArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className="circle-arrow"
      width="33"
      height="36"
      viewBox="0 0 33 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="circle-arrow__element"
        d="M20.502 11.7812L25.9364 17.5803L20.502 23.3793"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        className="circle-arrow__element"
        d="M9.08789 17.582H25.3913"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M31.7977 27.168C29.6855 30.012 26.6957 32.1293 23.2613 33.2131C19.8269 34.297 16.1263 34.2911 12.6956 33.1963C9.26484 32.1016 6.28216 29.9748 4.17956 27.124C2.07697 24.2733 0.963651 20.8467 1.00091 17.3405C1.03816 13.8344 2.22405 10.4308 4.38677 7.62278C6.54949 4.81478 9.57674 2.74819 13.03 1.72239C16.4832 0.69658 20.1832 0.764824 23.5938 1.91723C27.0044 3.06964 29.9487 5.24637 32 8.1321"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.707 14.0195L23.1176 17.809L19.707 21.5985"
        stroke="currentColor"
      />
      <path d="M12.8867 17.8086H22.5816" stroke="currentColor" />
      <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
    </svg>
  )
}

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.293 21.9805L12.8824 18.191L16.293 14.4015"
        stroke="currentColor"
      />
      <path d="M23.1133 18.1914L13.4184 18.1914" stroke="currentColor" />
      <circle
        cx="18"
        cy="18"
        r="17.5"
        transform="rotate(180 18 18)"
        stroke="currentColor"
      />
    </svg>
  )
}

export const Globe = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6719 17.9425C11.5378 17.7444 12.4358 17.0287 13.1955 15.7165C13.3127 15.5141 13.4246 15.3004 13.5305 15.0762C12.6342 14.8277 11.6753 14.6531 10.6719 14.5651V17.9425ZM9.67188 17.9425V14.507C9.50518 14.5022 9.33748 14.4998 9.16885 14.4998C8.2977 14.4998 7.4511 14.5647 6.6398 14.6872C6.79467 15.0557 6.96494 15.3999 7.14821 15.7165C7.90795 17.0287 8.80594 17.7444 9.67188 17.9425ZM10.6719 13.5615C11.8084 13.6555 12.8971 13.8549 13.9142 14.1453C14.3882 12.8183 14.6719 11.2281 14.6719 9.5V9.49978L10.6719 9.49978V13.5615ZM9.67188 9.49978V13.5066C9.50502 13.5021 9.33732 13.4998 9.16885 13.4998C8.17752 13.4998 7.21321 13.5794 6.29016 13.7298C5.90046 12.4915 5.67188 11.0513 5.67188 9.5V9.49978L9.67188 9.49978ZM10.6719 8.49978L14.6398 8.49978C14.5534 7.16119 14.2964 5.92706 13.9168 4.86211C12.9301 5.03571 11.8943 5.12794 10.8272 5.12794C10.7754 5.12794 10.7236 5.12773 10.6719 5.12729V8.49978ZM9.67188 5.09159V8.49978L5.70392 8.49978C5.79744 7.05057 6.091 5.7238 6.52355 4.60159C7.51735 4.85459 8.57377 5.02212 9.67188 5.09159ZM10.6719 4.12725C10.7236 4.12771 10.7754 4.12794 10.8272 4.12794C11.7593 4.12794 12.6632 4.05358 13.5259 3.91399C13.4213 3.69341 13.311 3.48299 13.1955 3.28352C12.4358 1.97126 11.5378 1.25563 10.6719 1.05748V4.12725ZM9.67188 1.05748V4.08948C8.71731 4.02555 7.80028 3.88337 6.93607 3.67371C7.00463 3.53943 7.0754 3.4093 7.14821 3.28352C7.90795 1.97126 8.80594 1.25563 9.67188 1.05748ZM15.6719 9.5V9.49978H18.6719V9.5C18.6719 11.6748 17.8551 13.6588 16.5117 15.162C15.9949 14.8963 15.4449 14.6584 14.8667 14.4512C15.3775 13.0094 15.6719 11.3141 15.6719 9.5ZM15.6418 8.49978H18.6136C18.419 6.83941 17.7459 5.32533 16.7358 4.09916C16.1537 4.31789 15.5415 4.50508 14.9047 4.65745C15.299 5.80465 15.5574 7.10747 15.6418 8.49978ZM5.55945 4.32318C5.09738 5.54896 4.79464 6.97038 4.702 8.49978H1.7301C1.94654 6.65335 2.75477 4.98783 3.96001 3.69799C4.46629 3.93278 5.00086 4.14203 5.55945 4.32318ZM1.67188 9.5L1.67187 9.49978H4.67188V9.5C4.67188 11.0963 4.89981 12.6006 5.30254 13.9212C4.60634 14.078 3.93847 14.2762 3.30571 14.5116C2.27834 13.1064 1.67188 11.374 1.67188 9.5ZM15.9908 3.30398C15.5249 3.46299 15.0389 3.6013 14.5357 3.71685C14.1589 2.86983 13.7013 2.13564 13.1828 1.54868C14.2343 1.94707 15.1862 2.54805 15.9908 3.30398ZM5.95533 3.39997C5.53728 3.26737 5.13447 3.11837 4.74891 2.95437C5.46367 2.36154 6.27712 1.88354 7.16095 1.54868C6.70824 2.06117 6.30195 2.6859 5.95533 3.39997ZM13.1828 17.4513C13.6815 16.8867 14.124 16.1859 14.4923 15.3794C14.9346 15.5364 15.358 15.7123 15.76 15.9051C15.0063 16.5632 14.1354 17.0904 13.1828 17.4513ZM7.16095 17.4513C5.945 16.9906 4.86227 16.259 3.98645 15.3302C4.51166 15.1501 5.06259 14.9963 5.63497 14.8718C6.04126 15.8936 6.56024 16.7713 7.16095 17.4513ZM10.1719 0C15.4186 0 19.6719 4.25329 19.6719 9.5C19.6719 14.7467 15.4186 19 10.1719 19C4.92517 19 0.671875 14.7467 0.671875 9.5C0.671875 4.25329 4.92517 0 10.1719 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Telephone = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.73378 12.1014L12.4402 14.4998L10.5557 16.6412C10.2951 16.9196 9.93426 17.0267 9.5734 16.8982C8.21016 16.3842 4.82211 14.8852 3.07797 12.7438C1.33383 10.6024 0.371539 7.3689 0.0307293 6.10547C-0.0494613 5.78425 0.0307293 5.44163 0.231206 5.18466L2.05554 3.12891L4.4813 6.34102L3.15816 8.37536L7.84931 13.3863L9.73378 12.1014Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17226 8.23925L11.651 8.35214L11.6293 9.02113L7.52362 8.88789L7.39038 4.78225L8.05937 4.76054L8.17226 8.23925Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79551 8.14364L13.2992 2.63999L13.7725 3.11328L8.26881 8.61694L7.79551 8.14364Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Email = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.45338 6.61974C5.19614 6.8597 4.9732 7.09966 4.73312 7.33963L2.17792 9.85923C2.02358 10.0135 1.95498 10.1849 2.02358 10.3906C2.14362 10.7677 2.5895 10.8705 2.88103 10.562C3.94427 9.53356 4.99035 8.47087 6.05359 7.40819C6.08789 7.35676 6.12219 7.30535 6.15648 7.25392C6.24223 7.33963 6.29368 7.39105 6.36227 7.44247L7.6313 8.59086C7.87138 8.81368 8.12862 8.81368 8.3687 8.59086C8.81458 8.19663 9.2433 7.78527 9.68917 7.39105C9.72347 7.35677 9.77492 7.32248 9.82637 7.27106C10.2208 7.66529 10.6152 8.05951 11.0096 8.45373L13.1361 10.5791C13.2733 10.7162 13.4448 10.7848 13.6506 10.7334C14.045 10.6305 14.1479 10.1677 13.8564 9.87637C13.1533 9.15648 12.433 8.45373 11.7299 7.75099C11.3526 7.37391 10.9753 6.99682 10.5809 6.6026C10.6324 6.55118 10.6667 6.5169 10.7181 6.48262L12.2615 5.07713L13.8392 3.63736C13.9936 3.50023 14.045 3.32883 13.9936 3.12315C13.9593 2.95175 13.8221 2.79749 13.6334 2.76321C13.4277 2.71179 13.2733 2.78035 13.119 2.91747C11.4555 4.4258 9.79207 5.95127 8.12862 7.45961C8.09432 7.49389 8.04287 7.52817 8.00857 7.56245L5.62487 5.41993C4.71597 4.5972 3.78992 3.75734 2.86388 2.91747C2.72669 2.78035 2.5552 2.72893 2.36656 2.78035C2.19507 2.81463 2.05788 2.96889 2.00643 3.14029C1.95498 3.34597 2.02358 3.50023 2.17792 3.6545C2.82958 4.2544 3.48124 4.83716 4.15005 5.43707L5.45338 6.61974ZM0 11.0076V2.50611C0.017149 2.47183 0.017149 2.43755 0.034298 2.40327C0.188639 1.46056 1.01179 0.757812 1.97213 0.757812C5.98499 0.757812 10.015 0.757812 14.0279 0.757812C14.9368 0.757812 15.7256 1.392 15.9486 2.28328C15.9657 2.35185 15.9829 2.43755 16 2.50611V11.0076C15.9829 11.0248 15.9828 11.059 15.9657 11.0762C15.8114 11.8989 15.2454 12.5502 14.4223 12.7045C14.045 12.773 13.6334 12.7559 13.239 12.7559C9.50054 12.7559 5.74491 12.7559 2.00643 12.7559C1.08039 12.7559 0.308682 12.1731 0.0685959 11.299C0.0514469 11.2133 0.017149 11.1105 0 11.0076Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 0V11M11 11V22M11 11H0M11 11L22 11" stroke="currentColor" />
    </svg>
  )
}
export const DropdownIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1 1L8 8L15 1" stroke="currentColor" />
    </svg>
  )
}
export const EmailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.0256 1.46875H2.48844C1.39808 1.46875 0.51416 2.36444 0.51416 3.46934V16.5339C0.51416 17.6388 1.39808 18.5345 2.48844 18.5345H22.0256C23.116 18.5345 23.9999 17.6388 23.9999 16.5339V3.46934C23.9999 2.36444 23.116 1.46875 22.0256 1.46875Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M0.51416 3.42969L12.257 11.8884L23.9999 3.42969"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M23.3656 18.0025L17.812 12.8281"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M6.70306 12.8281L1.14795 18.0041"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
